<template>
  <div v-if="subClassTab.length" class="class-tab-wrapper">
    <div class="class-tab-scroll">
      <div
        v-for="(item, index) in subClassTab"
        :key="index"
        :class="[
          'tab',
          {
            active: index === activeIndex
          }
        ]"
        @click="selectTab(index)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ClassTab',

  props: {
    subClassTab: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  methods: {
    selectTab(index) {
      this.activeIndex = index
      this.$emit('updateClassId', {
        class1Id: this.subClassTab[index]?.id
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.class-tab-wrapper {
  padding-left: 0.2rem;
}
.class-tab-scroll {
  width: 100%;

  height: 0.88rem;

  overflow-x: auto;
  // 滚动回弹效果（解决滚动卡顿问题）
  -webkit-overflow-scrolling: touch;
  @include flex(row, flex-start, center, nowrap);

  // 隐藏滚动条
  &::-webkit-scrollbar {
    display: none;

    background-color: transparent;
  }
  .tab {
    width: max-content;
    height: 0.48rem;

    margin-right: 0.16rem;
    padding: 0.1rem 0.24rem;

    background-color: #e9e9e9;
    border-radius: 0.28rem;

    flex: none;

    font-size: 0.24rem;
    color: #262626;

    box-sizing: border-box;

    &.active {
      background-color: #ffe0d8;
      border: 1px solid #ff3900;

      color: #ff3900;
    }
  }
}
</style>
